<div class="mt-4 min-h-screen flex justify-center items-center">
  <div class="placeholder flex flex-col items-center text-center">
    <img
      [src]="getImageSrc()"
      (error)="handleImageError($event)"
      class="mb-1 h-250px"
    />
    <span class="text-md text-gray-600 font-semibold">{{
      resolvePlaceholders(fields?.displayName || fields?.uiOptions?.text)
    }}</span>
    <span class="text-sm text-gray-500 w-500px">{{
      resolvePlaceholders(fields?.helpText || fields?.uiOptions?.subText)
    }}</span>
  </div>
</div>
